// extracted by mini-css-extract-plugin
module.exports = {"headerLogoArea":"styles_headerLogoArea__aFlYl","brand":"styles_brand__hP0Sa"};